import React, {useRef} from 'react';
import {openSignup} from '../../utils/helpers';
import "./PlansSection.css";
import {trackEvent} from '../../analytics/posthog';
import {useTrackOnView} from '../../analytics/useTrackOnView';

const PlansSection: React.FC = () => {
    const sectionRef = useRef<HTMLElement>(null);
    const advertiserPlanRef = useRef<HTMLDivElement>(null);
    const promoterPlanRef = useRef<HTMLDivElement>(null);
    const partnerPlanRef = useRef<HTMLDivElement>(null);

    useTrackOnView(sectionRef, 'landing_plans_section_viewed', {section_name: 'plans'});
    useTrackOnView(advertiserPlanRef, 'landing_advertiser_plan_viewed', {
        selected_role: 'advertiser',
        plan_name: 'Advertiser',
        plan_price: 95,
        plan_currency: 'USD'
    });
    useTrackOnView(promoterPlanRef, 'landing_promoter_plan_viewed', {
        selected_role: 'promoter',
        plan_name: 'Promoter',
        plan_price: 45,
        plan_currency: 'USD'
    });
    useTrackOnView(partnerPlanRef, 'landing_partner_plan_viewed', {
        selected_role: 'partner',
        plan_name: 'Partner',
        plan_price: 175,
        plan_currency: 'USD'
    });

    return (
    <section ref={sectionRef} id="plans" className="bg-[#f2f2f2] py-20">
        <div className="container text-center mb-16">
      <span className="text-xs bg-primary/10 text-[#1677ff] px-3 py-3">
        Pricing & Features
      </span>
            <h2 className="text-3xl font-medium mt-3 mb-4">Explore our plans</h2>
            <p className="text-gray-500 max-w-2xl mx-auto">
                Sign up for free today—no credit card needed. Dive into every dashboard and feature,
                then pick your subscription only when you’re ready to launch campaigns, drive clicks,
                or recruit your network.
            </p>
        </div>

        <div className="container grid md:grid-cols-3 gap-8 mb-16">
            <div ref={advertiserPlanRef} className="bg-white border border-[#1677ff] p-6 shadow flex flex-col">
                <div className="text-center">
                    <div className="text-4xl font-bold text-[#1677ff]">$95<small
                        className="text-base font-medium text-gray-500">/mo</small></div>
                    <h3 className="text-xl font-semibold mb-4">Advertiser</h3>
                </div>
                <ul className="text-gray-600 space-y-2 flex-1">
                    <li><span className="text-[#1677ff] mr-2">✔</span> Unlimited campaign creation</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> Set custom budgets & click-rates</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> Real-time analytics dashboard</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> Pay only for clicks—no hidden fees</li>
                </ul>
            </div>

            <div ref={promoterPlanRef} className="bg-white border border-[#1677ff] p-6 shadow flex flex-col">
                <div className="text-center">
                    <div className="text-4xl font-bold text-[#1677ff]">$45<small
                        className="text-base font-medium text-gray-500">/mo</small></div>
                    <h3 className="text-xl font-semibold mb-4">Promoter</h3>
                </div>
                <ul className="text-gray-600 space-y-2 flex-1">
                    <li><span className="text-[#1677ff] mr-2">✔</span> Browse & pick active campaigns</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> Unique affiliate link generation</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> Earn per click you drive</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> Detailed performance reports</li>
                </ul>
            </div>

            <div ref={partnerPlanRef} className="bg-white border border-[#1677ff] p-6 shadow flex flex-col">
                <div className="text-center">
                    <div className="text-4xl font-bold text-[#1677ff]">$175<small
                        className="text-base font-medium text-gray-500">/mo</small></div>
                    <h3 className="text-xl font-semibold mb-4">Partner</h3>
                </div>
                <ul className="text-gray-600 space-y-2 flex-1">
                    <li><span className="text-[#1677ff] mr-2">✔</span> Everything in Promoter plan</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> 40% commission on referrals</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> 10% commission on campaigns</li>
                    <li><span className="text-[#1677ff] mr-2">✔</span> Priority support & early features</li>
                </ul>
            </div>
        </div>

        <div className="container text-center">
            <button
                onClick={() => {
                    trackEvent('landing_signup_free_clicked', {
                        signup_source: 'landing_signup_free'
                    });
                    openSignup(undefined, 'landing_signup_free');
                }}
                className="signup-btn inline-flex items-center gap-3 px-8 py-3 text-white rounded-lg shadow hover:opacity-95 transition"
            >
                Sign up free
                <img src="/assets/images/plans-section/logo-white.svg" alt="" aria-hidden="true" className="w-5 h-5"/>
            </button>
        </div>
    </section>
    );
};

export default PlansSection;
